import { render, staticRenderFns } from "./MessageShow.vue?vue&type=template&id=57b1f9e4&"
import script from "./MessageShow.vue?vue&type=script&lang=js&"
export * from "./MessageShow.vue?vue&type=script&lang=js&"
import style0 from "./MessageShow.vue?vue&type=style&index=0&id=57b1f9e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports